import { useState } from 'react';
import { ZohoEstimateSummary, ZohoInvoiceSummary } from '../types';
import { customerApi } from '../services/customerApi';

export const useZohoFinanceCache = () => {
  const [zohoFinanceByCustomer, setZohoFinanceByCustomer] = useState<Record<string, { invoices: ZohoInvoiceSummary; estimates: ZohoEstimateSummary }>>({});
  const [loadingFinanceId, setLoadingFinanceId] = useState<string | null>(null);

  const loadFinance = async (customerId: string) => {
    setLoadingFinanceId(customerId);
    try {
      const data = await customerApi.getZohoFinance(customerId);
      setZohoFinanceByCustomer((prev) => ({ ...prev, [customerId]: data }));
      return data;
    } finally {
      setLoadingFinanceId(null);
    }
  };

  return {
    zohoFinanceByCustomer,
    setZohoFinanceByCustomer,
    loadingFinanceId,
    loadFinance,
  };
};
